import { RouteConfig } from 'vue-router'

const Privileges = () => import('../views/splus/Privileges.vue')
const PayOnBehalfOf = () => import('../views/splus/PayOnBehalfOf.vue')
const GrowthValueRecords = () => import('../views/splus/GrowthValueRecords.vue')

export const privilegesRoute: RouteConfig = {
  path: '/splus/privileges',
  name: 'splus_privileges',
  component: Privileges,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'VIP成长等级',
  },
}

export const payOnBehalfOfRoute: RouteConfig = {
  path: '/splus/pay-on-behalf-of',
  name: 'splus_pay_on_behalf_of',
  component: PayOnBehalfOf,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '找人帮付',
    needOpenidUnderWechat: true,
  },
}

export const growthValueRecordsRoute: RouteConfig = {
  path: '/splus/growth-value-records',
  name: 'splus_growth_value_records',
  component: GrowthValueRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的成长明细',
  },
}

export default [privilegesRoute, payOnBehalfOfRoute, growthValueRecordsRoute]
